var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Page',{attrs:{"title":"Dashboard"}},[_c('DashboardShortcuts')],1),_c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"4"}},[_c('TestingStatistics')],1),_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_c('DashGraph')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }